window.VWO = window.VWO || [];

window.VWO.event =
    window.VWO.event ||
    function () {
        window.VWO.push(['event'].concat([].slice.call(arguments)));
    };

export const VWO = window.VWO;
